var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudzeroLogoWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    fill: "#FFF",
    width: "800px",
    height: "800px",
    viewBox: "0 0 155.71701049804688 150.97000122070312",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.591 13.717 102.832.001 77.859 14.419 52.886 0 24.973 16.115l.001 28.837L0 59.37v27.435c0 20.744 11.16 40.076 29.127 50.448l23.759 13.717 24.973-14.418 24.973 14.418 27.912-16.114v-28.837l24.973-14.418V64.166c0-20.745-11.161-40.076-29.126-50.449M99.894 62.764v25.443l-22.035 12.722-22.035-12.722V62.764L77.859 50.04l22.035 12.723ZM49.947 88.606 30.505 99.831V76.983l19.442-11.225zm-16.849 15.716L52.54 93.098l19.787 11.423-19.441 11.225-18.117-10.459zm50.293.199 19.787-11.423 19.441 11.224-19.787 11.424zm-8.125-59.769L55.478 56.176V33.727l19.788-11.424zM47.699 61.067 27.912 72.49 8.471 61.266l19.787-11.424 10.75 6.207zm5.187-31.831L33.444 18.01 52.886 6.787 72.327 18.01zm48.559-.8L83.39 18.01l19.442-11.224 20.82 12.02c16.154 9.326 26.188 26.707 26.188 45.36v24.04L130.399 99.43V78.584c0-20.622-11.095-39.838-28.954-50.149Zm-45.966 91.802 19.787-11.425v22.45l-19.788 11.424v-22.449Zm49.946 0 19.442-11.225v22.449l-19.442 11.225z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudzeroLogoWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cloudzero-logo-white.57e5dccc12187f2a5091ad2be692d803.svg";